import { takeEvery, takeLatest } from 'redux-saga/effects';
import { AGENCY_MODULE } from '../../../configs/moduleNames';
import {
  LOAD_VEHICLES_LIST,
  CREATE_VEHICLES,
  DELETE_VEHICLES,
  EDIT_VEHICLES_BY_ID,
  LOAD_VEHICLES_BY_ID,
} from '../actions';

import loadVehiclesList from './loadVehiclesList';
import createVehicles from './createVehicles';
import loadVehiclesById from './loadVehiclesById';
import editVehiclesById from './editVehiclesById';
import deleteVehicles from './deleteVehicles';

export default function* watchDashboard() {
  yield takeLatest(AGENCY_MODULE + LOAD_VEHICLES_LIST, loadVehiclesList);
  yield takeLatest(AGENCY_MODULE + CREATE_VEHICLES, createVehicles);
  yield takeEvery(AGENCY_MODULE + LOAD_VEHICLES_BY_ID, loadVehiclesById);
  yield takeEvery(AGENCY_MODULE + EDIT_VEHICLES_BY_ID, editVehiclesById);
  yield takeEvery(AGENCY_MODULE + DELETE_VEHICLES, deleteVehicles);
}
